import React from 'react';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { checkmark, chevronDown, chevronForward, informationCircleOutline, lockClosedOutline, trophyOutline } from 'ionicons/icons';
import { NormalText, SmallText, Spacer, StrongText, Title } from '../../components/common';
import { IonIcon } from '@ionic/react';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { forwardTo, isEmptyObject } from '../../lib/utils';
import Layout from '../../components/layout';
import { getConfig } from '../../appConfig';
import { hexToRGBA, isDark, validHex } from '../../lib/colorUtils';


const formatTierData = (profile, type = 'spend') => {
    if (profile.current_tier && !isEmptyObject(profile.current_tier)) {
        const tiers = getConfig().tiers_json
        tiers.sort((a, b) => a[`${type}_required`] - b[`${type}_required`])
        const currentTierData = tiers.find(el => el.id == profile.current_tier.current_tier_id)
        const currentTierIndex = tiers.findIndex(el => el.id == profile.current_tier.current_tier_id)
        const nextTierData = tiers[currentTierIndex + 1]

        const tierByPointsIndex = tiers.reduce((idx, tier, i) => {
            if (profile.current_tier[`current_period_${type}`] >= tier[`${type}_required`]) {
                return i;
            }
            return idx;
        }, 0);
        const tierBasedOnPoints = tiers[tierByPointsIndex]
        currentTierData[`tier_based_on_${type}`] = tierBasedOnPoints.name
        if (nextTierData) {
            currentTierData[`${type}_until_next_tier`] = nextTierData[`${type}_required`] - profile.current_tier[`current_period_${type}`];
            if (profile.current_tier[`previous_period_${type}`] > 0 && profile.current_tier[`previous_period_${type}`] > profile.current_tier[`current_period_${type}`]) {
                currentTierData.percentage = Math.ceil((profile.current_tier[`current_period_${type}`] / nextTierData[`${type}_required`]) * 100);
            } else {
                currentTierData.percentage = Math.ceil((profile.current_tier[`current_period_${type}`] - currentTierData[`${type}_required`]) / (nextTierData[`${type}_required`] - currentTierData[`${type}_required`]) * 100);
            }
        } else {
            currentTierData[`${type}_until_next_tier`] = currentTierData[`${type}_required`] - profile.current_tier[`current_period_${type}`];

        }

        const maximumSpend = tiers[tiers.length - 1][`${type}_required`]

        return { maximumSpend, currentTierData, nextTierData }
    } else {
        return { currentTierData: false }
    }

}
const tierColor = (tier) => tier.color_hex ?? 'var(--ion-color-primary)'
const tierContrastColor = (tier) => `var(--okx-tier-contrast-color, ${validHex(tier.color_hex) ? (isDark(tier.color_hex) ? '#ffffff' : '#000000') : 'var(--okx-loyalty-header-color)'})`
const tierProgressBackground = (tier) => tier.color_gradient ?? tierColor(tier)
const BenefitIcon = ({ benefit }) => {
    if (benefit.icon_url) return <img className='loyalty-status-tier-perk-icon' src={benefit.icon_url} />
    if (benefit.icon_svg) return <IonIcon className='loyalty-status-tier-perk-icon' icon={benefit.icon_svg.trim().startsWith('<svg') ? `data:image/svg+xml;utf8,${benefit.icon_svg}` : `data:image/svg+xml;base64,${benefit.icon_svg}`} />
    return null
}
const Benefit = ({ benefit, __ }) => {
    return (
        <span className='loyalty-status-tier-perk'>
            <BenefitIcon benefit={benefit} />
            <SmallText style={{ fontSize: '12px' }}>{__(benefit.text)}</SmallText>
        </span>
    )
}
const tierColorLight = (tier) => validHex(tier.color_hex) ? hexToRGBA(tier.color_hex, 0.2) : 'var(--ion-color-gray)'

class LoyaltyStatusBanner extends React.Component {
    render() {
        const { __, profile } = this.props;
        const type = getConfig().general.tierType == 'points' ? 'points' : 'spend'

        const { currentTierData, nextTierData } = formatTierData(profile, type)
        if (!currentTierData) return null
        const formatValue = (value, includeZero = true) => type == 'spend' ? Basket.formatPrice(value, includeZero, false) : `${value} ${__(value == 1 ? 'pt' : 'pts')}`
        const untilNextTier = currentTierData[`${type}_until_next_tier`]
        return (
            <div onClick={() => forwardTo('/loyalty', { loyaltyStatus: true })} className='pointer loyalty-status-banner box-content' style={{ '--tier-color': tierColor(currentTierData), '--tier-contrast-color': tierContrastColor(currentTierData), '--tier-progress-background': tierProgressBackground(currentTierData) }}>
                <div className='loyalty-status-banner-header'>
                    <span className='loyalty-status-tier-icon'>
                        {currentTierData.icon?.includes('http') ?
                            <img src={currentTierData.icon} />
                            :
                            currentTierData.icon || <IonIcon icon={trophyOutline} />
                        }
                    </span>
                    <span className='loyalty-status-tier-info'>
                        <SmallText className='bold uppercase loyalty-status-text-dark'>{__('YOUR TIER')}</SmallText>
                        <StrongText>{__(currentTierData.name)}</StrongText>
                    </span>
                    {nextTierData ?
                        <IonIcon className='loyalty-status-text-dark' icon={chevronForward} />
                        :
                        <div className='loyalty-status-pill' style={{ backgroundColor: tierColor(currentTierData) }}>
                            <SmallText className='bold'>{__('TOP TIER')}</SmallText>
                        </div>
                    }
                </div>
                <div>
                    <div className='loyalty-status-progress'>
                        <div>
                            <span style={{ width: nextTierData ? `${currentTierData.percentage}%` : '100%' }}></span>
                        </div>
                    </div>
                    <Spacer size={1} />
                    {nextTierData ?
                        <div className='loyalty-status-progress-labels flex-col-wrapper flex-align-center flex-justify-between'>
                            <SmallText className='bold loyalty-status-text-dark'>
                                {`${formatValue(profile.current_tier[`current_period_${type}`])} ${type == 'spend' ? __('spent this year') : __('earned this year')}`}
                            </SmallText>
                            <SmallText className='bold' style={{ textAlign: 'end' }}>{`${formatValue(untilNextTier, false)} ${__('to')} ${__(nextTierData.name)}`}</SmallText>
                        </div>
                        :
                        <SmallText className='bold loyalty-status-text-dark'>{__("You've unlocked every reward this year")}</SmallText>
                    }
                </div>
            </div>
        );
    }
}

class LoyaltyStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openTierId: props.profile?.current_tier?.current_tier_id ?? null
        };
    }
    render() {
        const { __, profile } = this.props;
        const { openTierId } = this.state;
        const type = getConfig().general.tierType == 'points' ? 'points' : 'spend'

        const { maximumSpend, currentTierData, nextTierData } = formatTierData(profile, type)
        const formatValue = (value, includeZero = true) => type == 'spend' ? Basket.formatPrice(value, includeZero, false) : `${value} ${__(value == 1 ? 'pt' : 'pts')}`
        const tiers = getConfig().tiers_json
        const currentTierIndex = currentTierData ? tiers.findIndex(el => el.id == currentTierData.id) : -1
        return (
            <>
                {currentTierData &&
                    <div className='loyalty-status '>
                        <div className='loyalty-status-wrapper box-content'>
                            <div onClick={() => forwardTo('/loyalty-status')} className='loyalty-status-header flex-col-wrapper flex-align-center flex-justify-between'>
                                <div className='pointer flex-col-wrapper flex-align-center'>
                                    <StrongText className='uppercase'>{__('LOYALTY TIERS')}</StrongText>
                                    <IonIcon className='fill-text' icon={informationCircleOutline} />
                                </div>
                                <div className='loyalty-status-pill' style={{ backgroundColor: tierColor(currentTierData), '--tier-contrast-color': tierContrastColor(currentTierData) }}>
                                    <SmallText className='bold'>{__(currentTierData.name)}</SmallText>
                                </div>
                            </div>
                            <Spacer size={1} />
                            <NormalText>{type == 'spend' ? __('Earn annual spend to climb the ladder. Tiers reset each membership year.') : __('Earn annual points to climb the ladder. Tiers reset each membership year.')}</NormalText>

                            {nextTierData &&
                                <>
                                    <Spacer size={2} />
                                    <div className='loyalty-status-progress-labels flex-col-wrapper flex-align-center flex-justify-between'>
                                        <SmallText className='bold'>
                                            {`${formatValue(profile.current_tier[`current_period_${type}`])} ${type == 'spend' ? __('spent this year') : __('earned this year')}`}
                                        </SmallText>
                                        {nextTierData ?
                                            <SmallText className='bold' style={{ textAlign: 'end', '--tier-color': tierColor(currentTierData) }}>{`${formatValue(currentTierData[`${type}_until_next_tier`], false)} ${__('to')} ${__(nextTierData.name)}`}</SmallText>
                                            :
                                            currentTierData[`${type}_until_next_tier`] > 0 &&
                                            <SmallText className='bold' style={{ textAlign: 'end', '--tier-color': tierColor(currentTierData) }}>{`${formatValue(currentTierData[`${type}_until_next_tier`], false)} ${__('to keep')} ${__(currentTierData.name)}`}</SmallText>
                                        }
                                    </div>
                                    <Spacer size={1} />
                                    <div className='loyalty-status-progress' style={{ '--tier-color': tierColor(currentTierData), '--tier-progress-background': tierProgressBackground(currentTierData) }}>
                                        <div>
                                            <span style={{ width: `${currentTierData.percentage}%` }}></span>
                                        </div>
                                    </div>
                                </>
                            }
                            <Spacer size={4} />
                            <div className='loyalty-status-tiers'>
                                {tiers.map((tier, index) => {
                                    const isCurrent = index == currentTierIndex
                                    const isReached = index < currentTierIndex
                                    const isLocked = index > currentTierIndex
                                    const hasPerks = tier.benefits?.length > 0
                                    const isOpen = hasPerks && openTierId == tier.id
                                    return (
                                        <div key={tier.id} className={`loyalty-status-tier ${isLocked ? 'locked' : ''}`} style={isLocked ? { '--tier-color': 'var(--okx-loyalty-status-color-light)', '--tier-color-light': 'var(--okx-loyalty-status-color-light)', '--tier-contrast-color': 'var(--okx-loyalty-status-color-dark)' } : { '--tier-color': tierColor(tier), '--tier-contrast-color': tierContrastColor(tier), '--tier-color-light': tierColorLight(tier), ...(isCurrent ? { borderColor: tierColor(tier) } : {}) }}>
                                            {isCurrent &&
                                                <div className='loyalty-status-tier-banner'>
                                                    <SmallText className='bold'>{__('YOUR CURRENT TIER')}</SmallText>
                                                </div>
                                            }
                                            <div onClick={() => hasPerks && this.setState({ openTierId: isOpen ? null : tier.id })} className={`loyalty-status-tier-row ${hasPerks ? 'pointer' : ''}`}>
                                                <span className='loyalty-status-tier-icon'>
                                                    {isReached && <IonIcon icon={checkmark} />}
                                                    {isCurrent && <span className='loyalty-status-tier-dot'></span>}
                                                    {isLocked && <IonIcon icon={lockClosedOutline} />}
                                                </span>
                                                <span className='loyalty-status-tier-info'>
                                                    <StrongText>{__(tier.name)}</StrongText>
                                                    <SmallText className='bold loyalty-status-text-dark'>
                                                        {tier[`${type}_required`] > 0 ? formatValue(tier[`${type}_required`]) : __('Upon registration')}
                                                    </SmallText>
                                                </span>
                                                {hasPerks && <IonIcon icon={isOpen ? chevronDown : chevronForward} />}
                                            </div>
                                            {isOpen &&
                                                <>
                                                    {tier.inherits_previous && tiers[index - 1] &&
                                                        <div className='loyalty-status-tier-inherits'>
                                                            <SmallText className='bold loyalty-status-text-dark'>{__('All {tier} benefits, plus:', { tier: __(tiers[index - 1].name) })}</SmallText>
                                                        </div>
                                                    }
                                                    <div className='loyalty-status-tier-perks'>
                                                        {tier.benefits.map((benefit, i) => (
                                                            <Benefit key={i} benefit={benefit} __={__} />
                                                        ))}
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    )
                                })}
                            </div>
                            <Spacer size={3} />
                            <div style={{ background: 'var(--okx-loyalty-status-color-light)', height: '1px' }}></div>
                            <Spacer size={3} />

                            <div className='loyalty-status-renewal'>
                                <IonIcon className='loyalty-status-text-dark' icon={informationCircleOutline} />
                                <span className='loyalty-status-tier-info'>
                                    <StrongText className='label-color'>{`${__('Membership year resets')} ${moment(profile.current_tier.end_date).format('LLLL')}`}</StrongText>
                                    <SmallText className='bold loyalty-status-text-dark'>{`${__('You will start next year in')} ${__(currentTierData[`tier_based_on_${type}`])}`}</SmallText>
                                </span>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}


class LoyaltyStatusPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loyaltyStatusModalOpen: true
        };

    }
    componentDidMount() {
        if (!this.props.profile.current_tier || isEmptyObject(this.props.profile.current_tier)) {
            forwardTo('/loyalty')
        }
    }
    handleBack() {
        forwardTo('/loyalty', { loyaltyStatus: true })
    }
    render() {
        const { __, profile } = this.props;
        const type = getConfig().general.tierType == 'points' ? 'points' : 'spend'

        const { currentTierData, nextTierData } = formatTierData(profile, type)
        const formatValue = (value, includeZero = true) => type == 'spend' ? Basket.formatPrice(value, includeZero, false) : `${value} ${__(value == 1 ? 'pt' : 'pts')}`
        const tiers = getConfig().tiers_json
        const currentTierIndex = currentTierData ? tiers.findIndex(el => el.id == currentTierData.id) : -1
        return (
            <Layout backHandler={this.handleBack} color="transparent"
                headerWithTitle title={__('Your loyalty status')}>
                {currentTierData &&
                    <>
                        <Title className='web-only page-title-centered'>{__('Your loyalty status')}</Title>
                        <div className='mobile-only'>
                            <StrongText className='uppercase'>{__('HOW LOYALTY TIERS WORK')}</StrongText>
                            <Spacer size={1} />
                        </div>

                        <NormalText>{type == 'spend' ? __("Earn annual spend to climb the ladder. Every tier's benefits, all in one place.") : __("Earn annual points to climb the ladder. Every tier's benefits, all in one place.")}</NormalText>
                        {nextTierData &&
                            <>
                                <Spacer size={3} />
                                <div className='loyalty-status-progress-labels flex-col-wrapper flex-align-center flex-justify-between'>
                                    <SmallText className='bold'>
                                        {`${formatValue(profile.current_tier[`current_period_${type}`])} ${type == 'spend' ? __('spent this year') : __('earned this year')}`}
                                    </SmallText>
                                    <SmallText className='bold' style={{ textAlign: 'end', '--tier-color': tierColor(currentTierData) }}>{`${formatValue(currentTierData[`${type}_until_next_tier`], false)} ${__('to')} ${__(nextTierData.name)}`}</SmallText>
                                </div>
                                <Spacer size={1} />
                                <div className='loyalty-status-progress' style={{ '--tier-color': tierColor(currentTierData), '--tier-progress-background': tierProgressBackground(currentTierData) }}>
                                    <div>
                                        <span style={{ width: `${currentTierData.percentage}%` }}></span>
                                    </div>
                                </div>
                            </>
                        }
                        <Spacer size={4} />
                        <div className='loyalty-status-timeline'>
                            {tiers.map((tier, index) => {
                                const isCurrent = index == currentTierIndex
                                const isReached = index < currentTierIndex
                                const isLocked = index > currentTierIndex
                                const hasPerks = tier.benefits?.length > 0
                                return (
                                    <div key={tier.id} className='loyalty-status-timeline-item' style={{ '--tier-color': tierColor(tier), '--tier-contrast-color': tierContrastColor(tier), '--tier-color-light': tierColorLight(tier) }}>
                                        <div className='loyalty-status-timeline-track'>
                                            <span className='loyalty-status-tier-icon'>
                                                {isReached && <IonIcon icon={checkmark} />}
                                                {isCurrent && <span className='loyalty-status-tier-dot'></span>}
                                                {isLocked && <IonIcon icon={lockClosedOutline} />}
                                            </span>
                                            {index < tiers.length - 1 && <span className='loyalty-status-timeline-line'></span>}
                                        </div>
                                        <div className='loyalty-status-timeline-content'>
                                            <div className={`loyalty-status-tier ${isCurrent ? 'current' : ''}`} style={isCurrent ? { borderColor: tierColor(tier) } : {}}>
                                                {isCurrent &&
                                                    <div className='loyalty-status-tier-banner'>
                                                        <SmallText className='bold'>{__('YOUR CURRENT TIER')}</SmallText>
                                                    </div>
                                                }
                                                <div className='loyalty-status-tier-row'>
                                                    <span className='loyalty-status-tier-info'>
                                                        <StrongText>{__(tier.name)}</StrongText>
                                                        <SmallText className='bold loyalty-status-text-dark'>
                                                            {tier[`${type}_required`] > 0 ? formatValue(tier[`${type}_required`]) : __('Upon registration')}
                                                        </SmallText>
                                                    </span>
                                                </div>
                                                {hasPerks &&
                                                    <>
                                                        {tier.inherits_previous && tiers[index - 1] &&
                                                            <div className='loyalty-status-tier-inherits'>
                                                                <SmallText className='bold loyalty-status-text-dark'>{__('All {tier} benefits, plus:', { tier: __(tiers[index - 1].name) })}</SmallText>
                                                            </div>
                                                        }
                                                        <div className='loyalty-status-tier-perks'>
                                                            {tier.benefits.map((benefit, i) => (
                                                                <Benefit key={i} benefit={benefit} __={__} />
                                                            ))}
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        <Spacer size={3} />
                        <div style={{ background: 'var(--okx-loyalty-status-color-light)', height: '1px' }}></div>
                        <Spacer size={3} />
                        <div className='loyalty-status-renewal'>
                            <IonIcon className='loyalty-status-text-dark' icon={informationCircleOutline} />
                            <span className='loyalty-status-tier-info'>
                                <StrongText className='label-color'>{`${__('Membership year resets')} ${moment(profile.current_tier.end_date).format('LLLL')}`}</StrongText>
                                <SmallText className='bold loyalty-status-text-dark'>{`${__('You will start next year in')} ${__(currentTierData[`tier_based_on_${type}`])}`}</SmallText>
                            </span>
                        </div>

                    </>
                }
            </Layout>
        );
    }
}

const stateToProps = (state) => {
    const { profile, auth } = state.profile;
    return {
        profile,
        auth,
    };
};



const ConnectedLoyaltyStatusBanner = connect(stateToProps)(withTranslation((LoyaltyStatusBanner)));
const ConnectedLoyaltyStatus = connect(stateToProps)(withTranslation((LoyaltyStatus)));
const ConnectedLoyaltyStatusPage = connect(stateToProps)(withTranslation((LoyaltyStatusPage)));

export {
    ConnectedLoyaltyStatusBanner as LoyaltyStatusBanner,
    ConnectedLoyaltyStatus as LoyaltyStatus,
    ConnectedLoyaltyStatusPage as LoyaltyStatusPage
};